import {MapEvent} from '../events';
import {getConfigProps, MapProps} from './props';
import {AreaConstants, DetailStoreState, utils} from '@mc/redux';
import {Dispatch} from 'redux';
import ConfigActions from '../actions/ConfigActions';
import {connect} from 'react-redux';

/**
 * Mapuje stav do properties.
 *
 * @param state - Stav store.
 * @param ownProps - Vlastní properties.
 * @returns Properies.
 * @ignore
 */
function mapStateToProps<Event extends MapEvent>(state: any, ownProps: MapProps<Event>) {
    return {
        area: ownProps.area + '.frame',
        authInfo: utils.storeFromArea(state, AreaConstants.AUTH_INFO_AREA, false) as DetailStoreState,
        ...getConfigProps(utils.storeFromArea(state, ownProps.area + '.config')),
    };
}

/**
 * Mapuje dispatch do properties.
 *
 * @param dispatch - Dispatch funkce
 * @param ownProps - Vlastní properties.
 * @returns Properties.
 * @ignore
 */
function mapDispatchToProps<Event extends MapEvent>(dispatch: Dispatch, ownProps: MapProps<Event>) {
    return {
        dispatch,
        onTopicChange: topic => dispatch(ConfigActions.setTopic(ownProps.area, topic)),
        onBackgroundLayerChange: backgroundLayer =>
            dispatch(ConfigActions.setBackgroundLayer(ownProps.area, backgroundLayer)),
        onForegroundLayerChange: foregroundLayer =>
            dispatch(ConfigActions.setForegroundLayer(ownProps.area, foregroundLayer)),
        onLayersChange: layers => dispatch(ConfigActions.setLayers(ownProps.area, layers)),
        onCatalogNodesChange: catalogNodes => dispatch(ConfigActions.setCatalogNodes(ownProps.area, catalogNodes)),
        onLocationChange: location => dispatch(ConfigActions.setLocation(ownProps.area, location)),
        onZoomChange: zoom => dispatch(ConfigActions.setZoom(ownProps.area, zoom)),
        onFilterChange: filter => dispatch(ConfigActions.setFilter(ownProps.area, filter)),
    };
}

/**
 * Napojí komponentu mapy do store s konfigurací mapy.
 *
 * @param component - Komponenta pro napojení.
 * @returns Napojená komponenta.
 * @ignore
 */
export default function connectFull<CustomProps, Event extends MapEvent>(component) {
    return connect<
        ReturnType<typeof mapStateToProps>,
        ReturnType<typeof mapDispatchToProps>,
        CustomProps & MapProps<Event>
    >(
        mapStateToProps,
        mapDispatchToProps,
    )(component);
}
